import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const TodayHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 1.25rem;
`

export const TodaySubline = styled.p`
  font-size: ${tokens.font.body};
  color: ${tokens.text.muted};
`

export const StatBand = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: ${tokens.space.sm};
  margin-bottom: 1.5rem;

  @media (max-width: 1180px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 680px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const SectionStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const SectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  justify-content: space-between;
`

export const SectionTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const SectionCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.375rem;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  font-size: ${tokens.font.micro};
  font-weight: 600;
  color: ${tokens.text.secondary};
  font-variant-numeric: tabular-nums;
`

export const TodaySectionContent = styled.div`
  padding: 0.75rem 1rem;
  display: flex;
  flex-direction: column;
  height: auto;
`

export const TodayRow = styled.div<{ $danger?: boolean }>`
  display: grid;
  grid-template-columns: minmax(10rem, 14rem) minmax(0, 1fr) 6.5rem auto;
  align-items: center;
  column-gap: 1rem;
  row-gap: 0.5rem;
  min-height: 2.75rem;
  height: auto;
  padding: 0.5rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr auto;
    grid-template-areas:
      'identity actions'
      'location location'
      'meta meta';
  }
`

export const RowIdentity = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  min-width: 0;
  height: fit-content;

  @media (max-width: 900px) {
    grid-area: identity;
  }
`

export const RowName = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
  line-height: 1.25;
  white-space: nowrap;
`

export const RowLocation = styled.span`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
  overflow: hidden;
  font-size: ${tokens.font.micro};
  line-height: 1.25;
  color: ${tokens.text.muted};
  white-space: nowrap;
  text-overflow: ellipsis;

  svg {
    width: 0.75rem;
    height: 0.75rem;
    min-width: 0.75rem;
    min-height: 0.75rem;
    flex: none;
  }

  @media (max-width: 900px) {
    grid-area: location;
  }
`

export const RowMeta = styled.span`
  font-size: ${tokens.font.label};
  line-height: 1.25;
  color: ${tokens.text.secondary};
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  height: fit-content;

  @media (max-width: 900px) {
    grid-area: meta;
  }
`

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: flex-end;
  flex: none;
  height: fit-content;

  @media (max-width: 900px) {
    grid-area: actions;
    justify-content: flex-end;
  }
`

export const CleanRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 2.75rem;
  height: auto;
  padding: 0.5rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};

  &:last-child {
    border-bottom: none;
  }
`

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  font-size: ${tokens.font.body};
  color: ${tokens.text.muted};
`

export const LoaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;
`
